import React, { useState, useEffect, useCallback, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import Cookies from "universal-cookie";
import config from "../../config.js";
import Table from "../Table.js";

const UserGroupTable = ({ highlightedUserIDs = [], setSelectedUserRows }) => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const selectedUserIDsRef = useRef([]);

  const cookies = new Cookies();
  const headers = {
    Authorization: `Bearer ${cookies.get("userToken")}`,
    "Content-Type": "application/json",
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const res = await axios.get(`${config.BACKEND_URL}/users`, { headers });
        setUsers(res.data.data || []);
        setLoading(false);
      } catch (err) {
        console.log(err);
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  // Memoize columns to prevent unnecessary table rebuilds
  const columns = React.useMemo(
    () => [
      { title: "id", field: "id", visible: false },
      { title: "Username", field: "name", headerFilter: "input" },
    ],
    []
  );

  const handleSelectionChange = useCallback((selectedData) => {
    const selectedIds = selectedData.map((row) => row.id);
    const currentSelectedIds = JSON.stringify(selectedIds.sort());
    const previousSelectedIds = JSON.stringify(
      selectedUserIDsRef.current.sort()
    );
    if (currentSelectedIds !== previousSelectedIds) {
      selectedUserIDsRef.current = selectedIds;
      setTimeout(() => {
        if (setSelectedUserRows) {
          setSelectedUserRows(selectedIds);
        }
      }, 0);
    }
  }, []);

  const memoizedHighlightedUserIDs = React.useMemo(() => {
    return highlightedUserIDs;
  }, [highlightedUserIDs.join(",")]);

  return (
    <div className="UserGroupTable" style={{ padding: "25px" }}>
      {!loading && users.length > 0 && (
        <Table
          key="userGroupTable"
          tableID="userGroupTable"
          tableData={users}
          tableColumns={columns}
          displaySerial={true}
          isSelectable={true}
          highlightedRows={memoizedHighlightedUserIDs}
          onSelectionChange={handleSelectionChange}
        />
      )}
    </div>
  );
};

export default React.memo(UserGroupTable);
